module.exports = __webpack_public_path__ + "img/D.23ecb219.png";